import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export const MasterInvite = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ email: "", name: "" });
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await api.post("/master/invite", { email: f.email.trim(), name: f.name.trim() || null }); toast.success(`Invito inviato a ${f.email}: registrandosi dal link entra nella tua rete`); setF({ email: "", name: "" }); setOpen(false); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Invio non riuscito"); }
    finally { setBusy(false); }
  };
  if (!open) return <Button size="sm" className="sim-chip gap-1 bg-emerald-600 hover:bg-emerald-700 text-white" onClick={() => setOpen(true)} data-testid="master-invite-open"><Mail className="w-4 h-4" />Invita un dealer</Button>;
  return <div className="flex flex-wrap items-center gap-2 rounded-lg border border-border p-3 w-full" data-testid="master-invite-form">
    <p className="text-sm w-full text-muted-foreground">Gli mandiamo un'email con il link di registrazione: quando si registra entra in automatico nella tua rete.</p>
    <Input className="w-48" placeholder="Nome (facoltativo)" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="master-invite-name" />
    <Input className="w-64" type="email" placeholder="Email del dealer" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="master-invite-email" />
    <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" disabled={busy || !/^\S+@\S+\.\S+$/.test(f.email)} onClick={send} data-testid="master-invite-submit">{busy ? "Invio…" : "Invia invito"}</Button>
    <Button size="sm" variant="ghost" onClick={() => setOpen(false)} data-testid="master-invite-cancel">Annulla</Button>
  </div>;
};
